/* Moments Etched v7.5.0 — additive UI polish only. Core cart logic remains untouched. */
(() => {
  'use strict';
  const labels = {
    design: 'Step 1 of 3 · Configure your project',
    artwork: 'Step 2 of 3 · Assign your artwork',
    review: 'Step 3 of 3 · Review and add to cart'
  };
  function init(root) {
    if (!root || root.dataset.meV750Ready === 'true') return;
    root.dataset.meV750Ready = 'true';
    const fill = root.querySelector('[data-me-builder-progress-fill]');
    const copy = root.querySelector('[data-me-builder-progress-copy]');
    const primary = root.querySelector('[data-me-designer-primary-action]');
    const status = root.querySelector('[data-me-designer-cart-status]');
    const steps = [...root.querySelectorAll('[data-me-step-button]')];
    const panels = [...root.querySelectorAll('[data-me-step-panel]')];

    const update = () => {
      const active = steps.find(b => b.classList.contains('is-active') || b.getAttribute('aria-current') === 'step');
      const key = active?.dataset.meStepButton || 'design';
      const index = Math.max(0, ['design','artwork','review'].indexOf(key));
      if (fill) fill.style.width = `${((index + 1) / 3) * 100}%`;
      if (copy) copy.textContent = labels[key];
      steps.forEach((button, i) => button.classList.toggle('is-complete', i < index));
    };

    steps.forEach(button => button.addEventListener('click', () => requestAnimationFrame(update)));
    if (primary) primary.addEventListener('click', () => requestAnimationFrame(update));

    // Keep the visible progress copy synchronized when the core builder changes
    // active steps programmatically rather than through a direct click.
    if (steps.length) {
      new MutationObserver(() => requestAnimationFrame(update)).observe(root, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'aria-current', 'hidden']
      });
    }

    if (status) {
      new MutationObserver(() => {
        const text = status.textContent.trim().toLowerCase();
        const isError = /required|select|upload|check|error|unable|please|missing|choose/.test(text);
        status.classList.toggle('is-error', isError);
        if (text && isError) {
          const activePanel = panels.find(panel => !panel.hidden && panel.classList.contains('is-active')) || panels.find(panel => !panel.hidden);
          const invalid = activePanel?.querySelector('[aria-invalid="true"], :invalid');
          if (invalid && typeof invalid.focus === 'function') {
            invalid.setAttribute('aria-invalid', 'true');
            invalid.scrollIntoView({behavior: 'smooth', block: 'center'});
            setTimeout(() => invalid.focus({preventScroll: true}), 250);
          }
        }
        if (primary) {
          const loading = primary.disabled && /adding|processing|preparing|uploading/.test(text);
          primary.classList.toggle('is-loading', loading);
          primary.setAttribute('aria-busy', loading ? 'true' : 'false');
        }
      }).observe(status, {childList:true, characterData:true, subtree:true, attributes:true});
    }

    root.addEventListener('change', event => {
      const target = event.target;
      if (target?.matches?.('input,select,textarea')) {
        target.removeAttribute('aria-invalid');
        target.closest('.is-invalid')?.classList.remove('is-invalid');
      }
    });
    update();
  }

  const boot = () => document.querySelectorAll('[data-me-designer]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  new MutationObserver(boot).observe(document.documentElement, {childList:true, subtree:true});
})();
